/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid,jsx-a11y/no-static-element-interactions */
import classNames from 'classnames';
import Link from 'next/link';
import { ReactComponent as SvgExternal } from 'public/assets/icons/externallink.svg';
import {
  useCallback, useEffect, useRef, useState, useMemo,
} from 'react';
import { IWithChildren } from 'types';
import { SubscriberDataEvent, useAnalytics } from 'util/analytics';
import { useSettingsPrefetch } from 'settings/SettingsContext';
import styles from './Link.module.scss';

interface IProps {
  href: string,
  current: boolean,
  external: boolean,
  onActive: (ref: HTMLAnchorElement) => void,
  isRedesigned?: boolean,
  forceReload?: boolean,
}

export function TabLink({
  children,
  href,
  external,
  forceReload,
  current,
  onActive,
  isRedesigned,
}: IProps & IWithChildren) {
  const [enableTransition, setEnableTransition] = useState<boolean>(false);
  const ref = useRef<HTMLAnchorElement>(null);
  const prefetch = useSettingsPrefetch();

  const a = useAnalytics();
  const onClick = useCallback(() => {
    if (external) {
      a.subcriberEvent(SubscriberDataEvent.LiftAccessNavigation, { url: href });
    }
  }, [a, href, external]);

  useEffect(() => {
    setEnableTransition(true);
  }, []);

  useEffect(() => {
    if (ref.current && current) {
      onActive(ref.current);
    }
  }, [current]);

  const rendered = useMemo(() => (
    <a
      href={forceReload ? href : undefined}
      ref={ref}
      rel={external ? 'noopener noreferrer' : ''}
      target={external ? '_blank' : undefined}
      onClick={onClick}
      className={classNames(styles.link, {
        [styles.active]: current,
        [styles.external]: external,
        [styles.enableTransition]: enableTransition,
        [styles.redesigned]: isRedesigned,
      })}
    >
      {children}
      {external && <SvgExternal />}
    </a>
  ), [forceReload, href, ref, external, current, isRedesigned, enableTransition]);

  if (forceReload) {
    return rendered;
  }

  return (
    <Link href={href} passHref prefetch={prefetch}>
      {rendered}
    </Link>
  );
}
